const addItems = async function(items, properties = {}) {
  await fetch("/cart/add.json", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    },
    body: JSON.stringify({
      items: items
    })
  });
};

function isEmpty(str) {
    return (!str || str.length === 0 );
}

function get_sku(variantId) {
  return fetch(`/variants/${variantId}.js`)
    .then(response => response.json())
    .then(variant => variant.sku)
    .catch(error => {
      console.error('Error fetching variant:', error);
      return null;
    });
}

async function add_bundle_to_cart() {
  //todo: instead of using dataset, use currentVariant global variable
  const data = document.getElementById(`add_bundle_to_cart_button`).dataset.bundleVariants;
  if (isEmpty(data)) {
    return;
  }
  const variantids = data.split(",");
  const items = await Promise.all(
    variantids.map(async pair => {
      //console.log(pair); // pair = "2 x 123412213"

      const [amtStr, vidStr] = pair.split(" x ");
      const vid = parseInt(vidStr, 10);
      const quantity = parseInt(amtStr, 10) || 1;
      //const sku = await get_sku(vid);
      const properties = { };

      return {
        id: vid,
        quantity,
        properties
      };
    })
  );

  if (items.length == 0) {
    return;
  }
  await addItems(items);

  const cartDrawer = window.document.querySelector('cart-drawer');
  //refresh the cart
  if (cartDrawer) {
      fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newCartDrawer = html.querySelector('cart-drawer');

            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open()
            }
        })
        .catch(error => console.error("Error refreshing cart:", error));
  }
}